import { jsx as _jsx } from "react/jsx-runtime";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import s from "./Hidden.module.css";
const Hidden = (props) => {
    const { as: TagName = "div", children, visibility, hide } = props;
    const rootClassNames = classNames(s.root, ...responsiveClassNames(s, "--hidden", hide), visibility && s["--visibility"]);
    return _jsx(TagName, { className: rootClassNames, children: children });
};
Hidden.displayName = "Hidden";
export default Hidden;
